export const ACTIVE = 'ACTIVE';
export const INACTIVE = 'INACTIVE';

const FREE = 'FREE';
const USED = 'USED';

export const BOOKING_STATUSES = { FREE, USED };
export const LOCKER_STATUS = { ACTIVE, INACTIVE };

export const MODES = {
  NONE: 'NONE',
  PREPARATION: 'PREPARATION',
  UNPREPARATION: 'UNPREPARATION',
  VERIFICATION: 'VERIFICATION'
};

export const HISTORY_SIZE = 10;

export const CODE_TYPES = {
  AUTOMATIC: 'AUTOMATIC',
  MANUAL: 'MANUAL'
};

export const AUTOMATIC_TYPES = {
  CODE_LOCKS: 'CODE_LOCKS',
  SHAREBOX: 'SHAREBOX',
  FAKE: 'FAKE',
  OTHERS: 'OTHERS'
};

export const MANUAL_TYPES = {
  MANUAL: 'MANUAL'
};

export const MANUAL_CODE_TYPES = {
  BASIC: 'BASIC',
  ADVANCED: 'ADVANCED'
};
